module.exports = __webpack_public_path__ + "img/icon_woman.637f23d2.png";